
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sv",
      function () {
        return require("private-next-pages/sv/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sv"])
      });
    }
  